/*
    2023-05-12 为CTP趋势主控编写的后台管理页面
*/
<template>
  <div>
    <Row type="flex" justify="center">
      <Col>
        <h3
          style="color:#893448;font-size:18px;letter-spacing:0.4px;white-space: nowrap;"
        >{{ table_title }}</h3>
      </Col>
    </Row>
    <Row style="height:15px;"></Row>
    <Row type="flex"  align="middle">
        <Col offset=20 span=2>
        <Input search maxlength="60" placeholder="搜索关键字" v-model="current_strategy_search_model" 
          @on-blur="current_strategy_search_click" 
          @on-search="current_strategy_search_click"/>
        </Col>
        <Col span=1>
          <Tooltip transfer content="清空搜索项" :delay="1500">
            <Button style="font-size:20px;color:#0099FF;box-shadow:none" type="text" size="large" 
              shape="circle" icon="ios-close"
              @click="current_strategy_search_clear"
            ></Button>
          </Tooltip>
        </Col>
        <Col span=1>
        <Tooltip transfer content="刷新当前策略" :delay="1500">
            <Button style="font-size:20px;color:#0099FF;box-shadow:none" type="text" size="large" 
              shape="circle" icon="md-refresh" :loading="loop_update_current_strategy_loading"
              @click="this.update_current_strategy_click"
            ></Button>
        </Tooltip>
        </Col>
        </Row>
      <v-table
        :title="this.control_str_human_show_record_title"
        :title_info="this.control_str_human_show_record_info"
        :table_columns="this.control_str_human_show_record_table_columns"
        :table_data="this.current_strategy_data_show"
        :table_ref="this.control_str_human_show_record_ref"
        :max_height="1000"
        :init_table="this.control_str_human_show_record_init_table_func"
        :table_name_array="this.control_str_human_show_name_array"
        :show_top="false"
        :show_page="true"
        :table_page_size="50"
        :span_method="control_str_human_span"
      ></v-table>
    <v-params-confirm-view
        :strategy_id="modal_view_msg.strategy_id"
        :acc_id="modal_view_msg.acc_id"
        :open_modal_switch="modal_view_msg.open_modal_switch"
        :title="modal_view_msg.title"
        v-on:modal_click="modal_click"
      >
    </v-params-confirm-view>
  </div>
</template>


<script>
import table_view from "../components/TableView.vue";
import render_modal_view_params_confirm from '../components/TrendStrategy/ModalRenderConfirm.vue';
export default {
  name: "tools_control_strategy_human_ctp",
  components: {
    "v-table": table_view,
    "v-params-confirm-view":render_modal_view_params_confirm,
  },
  data() {
    return {
      control_str_human_set_str_id:null,
      control_str_human_set_modal:false,
      control_str_human_set_msg:{},
      control_str_human_set_mode:0,
      table_title: "趋势主控--运维监控",
      control_str_human_show_record_title: "",
      control_str_human_show_record_info: [],
      control_str_human_show_record_table_columns: [],
      control_str_human_show_record_table_data: [],
      // 用来匹配搜索功能
      current_strategy_data_show:[],
      control_str_human_show_record_ref: "control_trend_human_record_ref",
      control_str_human_show_name_array: [
        "账户编号", "账户余额", "账户浮盈", "百分比浮盈",
        "策略编号", "策略余额", "策略浮盈", "余额占比", 
        "开仓价值占比","策略持仓一览", "策略启停状态",
        "控制接口",
      ],
      timer: null,
      current_strategy_search_model:"",
      loop_update_current_strategy_loading:false,
      guide_handle_span_col:{},
      // 设置币种余额时使用的字典
      modal_view_msg:{
          acc_id:null, strategy_id:null,
          open_modal_switch:false, title:""
      }
    };
  },
  methods: {
    modal_click:async function(value) {
      this.modal_view_msg["open_modal_switch"] = false
      if (value["mode"] != "ok") {
        return null
      }
      var acc_id = value["acc_id"]
      var strategy_id = value["strategy_id"]
      var asset = value["asset"]
      var balance = value["balance"]

      this.$Message.success({
        background: true,
        content:acc_id + "账户" + strategy_id + "号策略设定" + asset + "币种" + balance + "个, 命令已经下达",
        duration: 2.3
      });
      
      setTimeout(async () => {
          let data = await this.$axios.get(
          this.$store.state.urlPort + "/control_trend_strategy_human_ctp",
            {
                params: {
                  mode: "set_strategy_balance",
                  acc_id: acc_id,
                  strategy_id: strategy_id,
                  asset: asset,
                  balance:balance
                }
            }
          )
          this.$Message.info({
              background: true,
              content:"趋势主控返回:"+data,
              duration: 10
            });
        }, 0)
      
    },
    change_open_switch: function (acc_id, strategy_id, purpose_status) {
        this.$Message.success({
          background: true,
          content:acc_id + "账户" + strategy_id + "号策略关闭开仓权限命令已经下达",
          duration: 2.3
        });

        setTimeout(async () => {
          let data = await this.$axios.get(
          this.$store.state.urlPort + "/control_trend_strategy_human_ctp",
            {
                params: {
                  mode: "change_one_strategy_switch",
                  acc_id: acc_id,
                  strategy_id: strategy_id,
                  value:purpose_status
                }
            }
          )
          this.$Message.info({
              background: true,
              content:"趋势主控返回:"+data,
              duration: 10
            });
        }, 0)
    },
    close_position_ok: function (acc_id, strategy_id) {
        this.$Message.success({
          background: true,
          content:acc_id + "账户" + strategy_id + "号策略平仓操作命令已经下达",
          duration: 2.3
        });

        setTimeout(async () => {
          let data = await this.$axios.get(
          this.$store.state.urlPort + "/control_trend_strategy_human_ctp",
            {
                params: {
                  mode: "close_position",
                  acc_id: acc_id,
                  strategy_id: strategy_id
                }
            }
          )
          this.$Message.info({
              background: true,
              content:"趋势主控返回:"+data,
              duration: 10
            });
        }, 0)
    },
    cancel: function () {
        this.$Message.info({
          background: true,
          content:'平仓操作取消',
          duration: 2.3
          });
    },
    setTimer: function(interval) {
      if (this.timer == null) {
        this.timer = setInterval(() => {
            this.update_current_strategy_click()
            this.current_strategy_search_click()
        }, interval);
      }
    },
    draw_table_control_str_human: async function() {
      let data = await this.$axios.get(
          this.$store.state.urlPort + "/control_trend_strategy_human_ctp",
          {
            params: {
              mode: "get_table_msg",
            }
          }
        )
      this.control_str_human_show_record_table_data = data["data"]
    },
    current_strategy_search_clear: function() {
      // 当前策略页面，单击了取消搜索按钮
      this.current_strategy_search_model = ""
      this.current_strategy_search_click()
    },
    // 指导symbol列合并单元格
    update_span_method: function(data) {
      this.guide_handle_span_col = {}
      for (var j = 0; j < data[0].length; j++) {
        this.guide_handle_span_col[j] = {}
        var start = 0
        this.guide_handle_span_col[j][0] = [1, 1]
        for (var i = 1; i < data.length; i++) {
          var current = data[i][j];
          var last = data[i-1][j];
          if (current == last) {
            this.guide_handle_span_col[j][i] = [0, 0]
            this.guide_handle_span_col[j][start][0] += 1
          } else {
            start = i
            this.guide_handle_span_col[j][i] = [1, 1]
          }
        }
      }
    },
    // 对状态页面的表格进行行合并，优化显示效果
    control_str_human_span: function({row, column, rowIndex, columnIndex}) {
      // 策略状态、执行工具不要进行合并
      if (columnIndex < 4) {
        return this.guide_handle_span_col[columnIndex][rowIndex]
      }
    },
    current_strategy_search_click: function() {
      // 当前策略页面中，单击了搜索按钮
      // 关键字
      if (this.current_strategy_search_model.length == 0) {
        this.current_strategy_data_show = JSON.parse(JSON.stringify(this.control_str_human_show_record_table_data))
      } else {
        var data = []
        for (var i = 0; i < this.control_str_human_show_record_table_data.length; i++) {
          if (this.current_strategy_search_model.indexOf(":") != "-1") {
            var _current_strategy_search_model = this.current_strategy_search_model.split(":")[1]
          } else {
            var _current_strategy_search_model = this.current_strategy_search_model
          }

          var tmp = JSON.parse(JSON.stringify(this.control_str_human_show_record_table_data[i]))
          for (var j = 0; j < tmp.length; j++) {
            var column = this.control_str_human_show_record_table_columns[j]["title"]
            // 表头搜索
            if (this.current_strategy_search_model.indexOf(":") != "-1" & this.current_strategy_search_model.split(":")[0] != column) {
                continue
            }

            if (tmp[j].toString().indexOf(_current_strategy_search_model) != "-1" || 
                tmp[j].toString().indexOf(_current_strategy_search_model.toUpperCase()) != "-1") {
                data.push(tmp)
                break
            }
          }
          this.current_strategy_data_show = data
        }
      }
      this.update_span_method(this.current_strategy_data_show)
    },
    control_str_human_show_record_init_table_func: function() {
      const name_array = this.control_str_human_show_name_array;
      this.control_str_human_show_record_table_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        /*if (i==3) {
          //越过控制接口，不显示再表格中
          continue
        }*/
        this.control_str_human_show_record_table_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        });
      }
      this.control_str_human_show_record_table_columns[0]["width"] = 105;
      this.control_str_human_show_record_table_columns[1]["tooltip"] = true;
      //this.control_str_human_show_record_table_columns[2]["minwidth"] = 205;
      this.control_str_human_show_record_table_columns[3]["render"] = (h, params) => {
        var value = this.current_strategy_data_show[params["index"]][3]
        if (value.toString().indexOf("-") == -1) {
          var _color = "#006633";
        } else {
          var _color = "#ed4014";
        }
        return h("div", [
          h(
            "span",
            {
              style: {
                color: _color
              }
            },
            value
          )
        ]);
      }
      this.control_str_human_show_record_table_columns[2]["tooltip"] = true;
      this.control_str_human_show_record_table_columns[5]["tooltip"] = true;
      this.control_str_human_show_record_table_columns[6]["tooltip"] = true;
      this.control_str_human_show_record_table_columns[9]["tooltip"] = true;

      this.control_str_human_show_record_table_columns[11]["width"] = 150;
      this.control_str_human_show_record_table_columns[11]["render"] = (h, params) => {
        var acc_id = this.current_strategy_data_show[params["index"]][0]
        var str_id = this.current_strategy_data_show[params["index"]][4]
        var current_switch = this.current_strategy_data_show[params["index"]][10]
        var value = current_switch == "开"?"关闭":"开启"
        //var revalue = current_switch == "开"?"开启":"关闭"
        var purpose_status = current_switch == "开"?false:true

        return h("div", {
          style: {
              display: "flex",
              "justify-content": "space-around",
              "align-items": "center"
          }
        },[
          h("Poptip", {
            props: {
              confirm:true,
              transfer:true,
              title:acc_id+"号账户"+str_id+"号策略"+",执行平仓, 是否确认",
              "ok-text":"是",
              "cancel-text":"否"
            },
            on:{
              "on-ok":() => {this.close_position_ok(acc_id, str_id)},
              "on-cancel":() => {this.cancel()}
            }
          },[
          this.$createElement(
            "Button",
            {
              props: {
                //type: "error",
                size: "small",
                loading: false,
              },
            },
            "平仓"
          )]),
          h("Poptip", {
            props: {
              confirm:true,
              transfer:true,
              title:acc_id+"号账户"+str_id+"号策略,"+ value + "开仓权限, 是否确认",
              "ok-text":"是",
              "cancel-text":"否"
            },
            on:{
              "on-ok":() => {this.change_open_switch(acc_id, str_id, purpose_status)},
              "on-cancel":() => {this.cancel()}
            }
          },[
          this.$createElement(
            "Button",
            {
              props: {
                //type: "error",
                size: "small",
                loading: false,
              },
            },
            value
          )]),
          this.$createElement(
            "Button",
            {
              props: {
                // type: "warning",
                size: "small",
                loading: false,
              },
              style: {
              },
              on: {
                click: () => {
                  this.modal_view_msg.acc_id = acc_id
                  this.modal_view_msg.strategy_id = str_id
                  this.modal_view_msg.title = "设定"+acc_id+"号账户"+str_id+"号策略的余额",
                  this.modal_view_msg.open_modal_switch = true
                }
              }
            },
            "钱包"
          )
        ]);
      };
    },
    update_current_strategy_click: function() {
      // 刷新按钮被单击，刷新一次所有策略
      this.loop_update_current_strategy_loading = true
      setTimeout(async () => {
        await this.draw_table_control_str_human()
        this.current_strategy_search_click()
        this.loop_update_current_strategy_loading = false
      }, 800);
    },
  },
  mounted() {
    setTimeout(async () => {
      this.loop_update_current_strategy_loading = true
      await this.draw_table_control_str_human()
      this.current_strategy_search_click()
      this.loop_update_current_strategy_loading = false
    }, 0)
  },
  created: function() {
    clearInterval(this.timer);
    this.timer = null;
    // 3分钟一刷新
    this.setTimer(3 * 60 * 1000);
  },
};
</script>

<style scoped>
.header-collapse {
  background-color: rgba(255, 255, 255, 0.2);
}
.panel-name {
  display: flex;
  font-size: 18px;
  color: #2b85e4;
  letter-spacing: 0.4px;
  white-space: nowrap;
}
.panel-content {
  font-size: 15px;
  letter-spacing: 0.4px;
  white-space: nowrap;
}
.demo-drawer-hearde {
  width: 100%;

  text-align: center;
  background: #fff;
}
</style>